import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLogin from "./AdminLogin/AdminLogin";
import AdminDashboard from "./AdminDashboard/AdminDashboard";
import GeneralInfo from "./GeneralInfo/GeneralInfo";
import Downloads from "./Downloads/Downloads";
import OnlineSubmissions from "./OnlineSubmissions/OnlineSubmissions"; 
import ReviewerSubmissions from "./ReviewerSubmissions/ReviewerSubmissions"; 
import JournalMetrics from "./JournalMetrics/JournalMetrics"; 
import EditorialBoard from "./EditorialBoard/EditorialBoard"; 
import ContactList from "./Contact/Contact"; 
import Profile from "./Profile/Profile"; 
import JournalVolume from "./JournalVolume/JournalVolume"; 
import Notifications from "./Notifications/Notifications"; 
import CallForPapers from "./CallForPapers/CallForPapers"; 
import ChangePassword from "./ChangePassword/ChangePassword"; 

import AdminLayout from "./AdminLayout";
import { ProfileContextProvider } from "./Context/ProfileContext";
import './assets/dark-theme-override.css'; 

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("adminToken") ? true : false;
  
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

const AdminApp = () => {
  return (
    <ProfileContextProvider>
      <div className="admin-app">
        <Routes>
          <Route path="login" element={<AdminLogin />} />
        
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminDashboard />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="general-info"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <GeneralInfo />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
     

        <Route
          path="downloads"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Downloads />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="online-submissions"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <OnlineSubmissions />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="reviewer-submissions"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ReviewerSubmissions />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
     

        <Route
          path="journal-metrics"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <JournalMetrics />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="editorial-board"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <EditorialBoard />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="contacts"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ContactList />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="profile"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Profile />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="journal-volumes"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <JournalVolume />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
     

        <Route
          path="notifications"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Notifications />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="call-for-papers"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <CallForPapers />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="change-password"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ChangePassword />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
     
        <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
      </div>
    </ProfileContextProvider>
  );
};

export default AdminApp;